import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box, Button, Container, FormHelperText, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import RtlProvider from '../../../Components/RtlProvider';
import { MdDeleteOutline } from "react-icons/md";
import { ContextNotification, severitys } from '../../../App';
import helper from '../../../helper';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import planApi from '../../../api/planApi';
import hotelApi from '../../../api/hotelApi';
import cityApi from '../../../api/cityApi';
import ConfirmationDialog from '../../../Components/ConfirmationDialog';
import BedCountCircles from '../../../Components/BedCountCircles';
import hotelStructureApi from '../../../api/hotelStructureApi';
import staticVariablesApi from '../../../api/staticVariablesApi';
import Loading from '../../../Components/Loading';
import BeatLoading from '../../../Components/Loader/BeatLoader';
import enumMapper from '../../../enumMapper';
import { useReactToPrint } from 'react-to-print';
import { MdClose, MdPrint } from "react-icons/md";


const EditPlan = () => {
  const [HotelPlans, SetHotelPlans] = useState([])
  const { open, setOpen } = useContext(ContextNotification);
  const [Cities, setCities] = useState([]);
  const [Hotels, setHotels] = useState([]);
  const [hotelStructureIds, setHotelStructureIds] = useState([])
  const [HotelStructure, SetHotelStructure] = useState(null);
  const [planEditInfo, setPlanEditInfo] = useState(null)
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteData, setDeleteData] = useState(null);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitDelete, setSubmitDelete] = useState(false);

  const schema = yup.object().shape({
    CityConsistency: yup.string().required("شهر را انتخاب نمایید"),
    hotelId: yup.string().required("هتل را انتخاب نمایید"),
    hotelStructureId: yup.string().required("ساختار را انتخاب نمایید"),
    PlanCode: yup.string().required("پلان را انتخاب نمایید"),
    RoomId: yup.string().required("اتاق را انتخاب نمایید")
  });
  const { register, setValue, handleSubmit, formState: { errors }, control, watch, resetField, getValues } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });
  const hotelStructureId = watch("hotelStructureId")
  const onSubmit = (data) => {
    setSubmitLoading(true);
    const array = data.RoomId.split(',')
    if (array.length > 1) {
      setOpen({ IsEnable: true, Message: "فقط یک اتاق انتخاب نمایید", severity: severitys.error });
      setSubmitLoading(false);
    }
    else {
      planApi.AddRoomToPlan(data).then(async (res) => {
        if (res.data.success) {
          resetField("RoomId");
          const hotelStructure = await fetchHotelStructureById(hotelStructureId);
          SetHotelStructure(hotelStructure);
          resetField("PlanCode");
          GetPlanHotelDropDown(hotelStructureId);
          setPlanEditInfo(null);
          setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
        }
      }).catch(err => {
        if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }
        else {
          setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
        }
      }
      ).finally(() => { setSubmitLoading(false); });

    }


  };
  useEffect(() => {
    GetCityDropDown();
  }, []);

  const contentToPrint = useRef(null);
  const handlePrint = useReactToPrint({
    documentTitle: "Print This Document",
    onBeforePrint: () => { },
    onAfterPrint: () => { },
    removeAfterPrint: true,
  });

  const handleOpenDelete = (data) => {
    setOpenDelete(true);
    setDeleteData(data)
  };
  const handleCityChanged = useCallback(async (id) => {
    resetField("hotelId");
    setHotels(null);
    resetField("RoomId");
    resetField("PlanCode");
    SetHotelPlans(null);
    setPlanEditInfo(null);




    setHotelStructureIds([]);
    resetField("hotelStructureId")
    SetHotelStructure(null)

    if (id) {
      const hotels = await fetchHotelsByCityConsistency(id);
      setHotels(
        hotels.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }
  }, []);
  const handleHotelChanged = useCallback(async (id) => {
    resetField("RoomId");
    resetField("PlanCode");
    SetHotelPlans(null);
    setPlanEditInfo(null);
    // SetHotelStructure(null);
    // if (id) {
    //   const hotelStructure = await fetchHotelStructureByHotelId(id);
    //   SetHotelStructure(hotelStructure);
    //   GetPlanHotelDropDown(id);
    // }
    setHotelStructureIds([]);





    resetField("hotelStructureId")
    SetHotelStructure(null)


    if (id) {
      const hotelStructureIds = await fetchHotelStrutureDropDown(id);
      const arr = helper.DictionayToList(hotelStructureIds);
      const mappedReponse = arr.map((r) => {
        return {
          id: r.key,
          label: r.value
        };
      });
      setHotelStructureIds(mappedReponse);

      if (arr.length === 1) {
        setValue("hotelStructureId", arr[0].key);

        SetHotelStructure(null);
        const hotelStructure = await fetchHotelStructureById(arr[0].key);
        SetHotelStructure(hotelStructure);


        GetPlanHotelDropDown(arr[0].key);

      }
    }
  }, []);

  const fetchHotelStructureById = async (id) => {
    try {
      let res = await hotelStructureApi.GetHotelStructure(id);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };
  const handleHotelStructureIdChanged = async (id) => {

    // resetField("");
    SetHotelStructure(null);
    if (id) {

      const hotelStructure = await fetchHotelStructureById(id);
      SetHotelStructure(hotelStructure);
      GetPlanHotelDropDown(id);
    }
  };
  const fetchHotelStrutureDropDown = async (hotelId) => {
    try {
      let res = await hotelStructureApi.HotelStrutureDropDown(hotelId);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };
  const handlePlanChanged = useCallback(async (id) => {
    // resetField("");
    if (id) {
      //GetColor(id)
      GetPlanEditInfo(id, watch('hotelStructureId'));
    }
  }, []);

  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        setCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };
  const handleRemoveRoomFromPlan = () => {
    if (deleteData) {
      setSubmitDelete(true);
      planApi.RemoveRoomToPlan(deleteData.roomId, deleteData.roomPlanInfo?.planCode).then(async (res) => {
        if (res.data.success) {

          const hotelStructure = await fetchHotelStructureById(hotelStructureId);
          SetHotelStructure(hotelStructure);
          setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
        }
      }).catch(err => {
        if (err.response) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
      }
      ).finally(() => { setOpenDelete(false); setDeleteData(null); setSubmitDelete(false) });

    }
  };
  const fetchHotelsByCityConsistency = async (cityConsistency) => {
    try {
      let res = await hotelApi.HotelDropDown(cityConsistency);
      if (res.status == 200) {
      }
      const arr = helper.DictionayToList(res.data.data)
      return arr;
    }
    catch (err) {
      console.error(err);
    }
  };


  const GetPlanEditInfo = (planCode, hotelStructureId) => {
    hotelStructureApi.GetPlanEditInfo(planCode, hotelStructureId)
      .then((res) => {
        setPlanEditInfo(res.data.data)

      }).catch(err => console.log(err))
  }

  const GetPlanHotelDropDown = (structureId) => {
    hotelStructureApi.PlanCodeHotelStructureDropDown(structureId).then(res => {
      const arr = helper.DictionayToList(res.data.data);
      SetHotelPlans(arr.map((item) => {
        return {
          id: item.key,
          label: item.value
        };
      }));
    }).catch(err => console.log(err));
  };
  return (
    <Container component="main" maxWidth={false}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input type="hidden" {...register("RoomId")} />
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2}>
            ویرایش پلان
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                loading={!Cities?.length}
                control={control}
                options={Cities ?? []}
                name="CityConsistency"
                placeholder="شهر"
                onChange={handleCityChanged}
                disabled={!Cities?.length}
                error={!!errors?.CityConsistency}
                helperText={errors?.CityConsistency?.message}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                loading={watch("CityConsistency") && !Hotels?.length}
                control={control}
                options={Hotels ?? []}
                name="hotelId"
                placeholder="هتل"
                onChange={handleHotelChanged}
                disabled={!Hotels?.length}
                error={!!errors?.hotelId}
                helperText={errors?.hotelId?.message}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                loading={watch("hotelId") && !hotelStructureIds?.length}
                control={control}
                options={hotelStructureIds ?? []}
                name="hotelStructureId"
                placeholder="ساختار"
                onChange={handleHotelStructureIdChanged}
                disabled={!hotelStructureIds?.length || hotelStructureIds?.length === 1}
                style={{
                  border: "none",
                  padding: 0,
                }}
                error={!!errors?.hotelStructureId}
                helperText={errors?.hotelStructureId?.message}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                loading={watch("hotelStructureId") && !HotelPlans?.length}
                control={control}
                options={HotelPlans ?? []}
                name="PlanCode"
                placeholder="پلان"
                onChange={handlePlanChanged}
                disabled={!HotelPlans?.length}
                error={!!errors?.PlanCode}
                helperText={errors?.PlanCode?.message}
              />
              {planEditInfo && <> <Box
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: 1,
                  bgcolor: planEditInfo?.colorCode,
                  marginTop: 1
                }}
              />
                <Box>
                  <Typography>اتاق 2 تخته: {planEditInfo?.doubleRoomCount}</Typography>
                  <Typography>اتاق 3 تخته: {planEditInfo?.tripleRoomCount}</Typography>
                </Box>
              </>
              }
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button type="submit" variant="contained" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} />افزودن اتاق به پلان</Button>
              <FormHelperText error={!!errors?.RoomId}>{errors.RoomId?.message}</FormHelperText>
            </Grid>
            <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                <Tooltip title="چاپ" placement="top">
                                  <IconButton style={{ margin: '2px' }} onClick={() => {
                                    handlePrint(null, () => contentToPrint.current);
                                  }}>
                                    <MdPrint color='rgb(22, 95, 129)' />
                                  </IconButton>
                                </Tooltip>
                              </Box>
            <Grid item xs={12}>
              {
                //hotelStructureId !== undefined && hotelStructureId !== "" && (HotelStructure?.hotelFloorDto === null ? <p className="error"> طبقات این هتل تعریف نشده است، ابتدا طبقات و اتاق های این هتل را تعریف نمایید</p> :
                watch("hotelStructureId") ?
                  !HotelStructure ? <Loading /> :
                    HotelStructure?.hotelFloorDto?.length === 0 ? <p className="error"> طبقات این هتل تعریف نشده است، ابتدا طبقات و اتاق های این هتل را تعریف نمایید</p> : (
                      <div style={{ overflowX: 'auto' }}>
                        <div ref={contentToPrint} dir='rtl' style={{ textAlign: 'center' }}>
                        <table style={{border:'solid 3px #000'}} border={1} cellSpacing={0} cellPadding={0} align='center'>
                          <thead style={{ backgroundColor: '#0070c0', color: '#ffffff' }}>
                            <tr>
                              <th>طبقه</th>
                              <th colSpan={HotelStructure?.maxRoomCountOfFloor}>اتاق</th>
                            </tr>
                          </thead>
                          <tbody style={{ textAlign: 'center' }}>
                            {
                              HotelStructure?.hotelFloorDto?.map((row, index) => (
                                <tr key={row.index}>
                                  <th key={row.floorId}>{row.number}</th>
                                  {
                                    row.floorsRoomDto.map((roomdto, i) => (
                                      <td key={roomdto?.roomId} className={helper.RoomTypeBorderColor(roomdto)} style={{ background: roomdto?.roomPlanInfo != null ? roomdto?.roomPlanInfo?.colorCode : "" }}
                                        onClick={(e) => {
                                          if (roomdto?.roomPlanInfo === null && planEditInfo !== null) {
                                            const RoomId = getValues("RoomId");
                                            if (!e.currentTarget.style.background) {
                                              if (RoomId !== "" &&
                                                RoomId !== null &&
                                                RoomId !== undefined) {
                                                setValue("RoomId", RoomId.concat(",", roomdto?.roomId))
                                                e.currentTarget.style.background = planEditInfo?.colorCode;
                                              }
                                              else {
                                                e.currentTarget.style.background = planEditInfo?.colorCode;
                                                setValue("RoomId", roomdto?.roomId)
                                              }
                                            }
                                            else {
                                              e.currentTarget.style.removeProperty("background");
                                              const array = getValues("RoomId").split(',')
                                              const filteredItems = array.filter(item => item !== roomdto?.roomId);
                                              setValue("RoomId", filteredItems.join(","))
                                            }

                                          }
                                        }}>
                                        {
                                          <div dir='ltr'> {
                                            roomdto?.roomPlanInfo && (<Tooltip title="حذف اتاق از پلان" placement="top">
                                              <IconButton onClick={() => {
                                                // handleRemoveRoomFromPlan(roomdto?.roomId, roomdto?.roomPlanInfo?.id)
                                                handleOpenDelete(roomdto)
                                              }}>
                                                <MdDeleteOutline />
                                              </IconButton>
                                            </Tooltip>)
                                          }

                                            {roomdto?.roomNumberWithCode}
                                          </div>
                                        }
                                        <div style={{ width: '60px' }}>
                                          <BedCountCircles roomdto={roomdto} />
                                        </div>
                                      </td>

                                    ))
                                  }
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        </div>
                      </div>
                    ) : ""
              }
            </Grid>
          </Grid>
          <ConfirmationDialog
            open={openDelete}
            handleClose={() => setOpenDelete(false)}
            func={handleRemoveRoomFromPlan}
            loading={submitDelete}
          />
        </RtlProvider>
      </form>
    </Container>
  )
}
export default EditPlan;